import {useEffect, useRef} from 'react';
import useSnackbar from '../hooks/useSnackbar';
import {UPLOAD_STATUS_EVENT} from '../util/FileUtils';

// Mounted once (beside BidmiiSnackbar in MainRouter) so upload failures from
// any screen surface the user-facing message dispatched by handleFiles.
export default function UploadFailureSnackbarListener() {
  const {openSnackbar} = useSnackbar();
  const openSnackbarRef = useRef(openSnackbar);
  openSnackbarRef.current = openSnackbar;

  useEffect(() => {
    const onUploadStatus = (event: Event) => {
      const message = (event as CustomEvent).detail?.message;
      if (message) {
        openSnackbarRef.current(message, 'error', {
          duration: 8000,
          force: true,
        });
      }
    };
    window.addEventListener(UPLOAD_STATUS_EVENT, onUploadStatus);
    return () =>
      window.removeEventListener(UPLOAD_STATUS_EVENT, onUploadStatus);
  }, []);

  return null;
}
